import { Badge, Button, cn, Container, HemedLogo, Logo, ShemedLogo } from "@emed-labs/ui-kit";
import AngleLeftIcon from "./icons/icons/AngleLeftIcon";
import { useNavigator } from "../providers/NavigatorProvider";
import { isNil } from "lodash";

interface Tag {
	label: string;
	onClick?: () => void;
}

interface HeaderProps {
	alignment?: "center" | "left" | "right";
	className?: string;
	tags?: Tag[];
	theme?: "default" | "shemed" | "hemed";
}

export const Header = ({ alignment = "center", className, tags = [], theme = "default" }: HeaderProps) => {
	const navCtx = useNavigator();
	const backDisabled =
		isNil(navCtx.currentPage?.allowBack) || navCtx.currentPage?.allowBack === false || navCtx.pageStack.length < 1;
	const headerClasses = cn([
		"flex",
		"p-5",
		"mb-6",
		"shadow-md",
		"dark:shadow-white",
		"bg-primary-bg",
		"text-heading",
		className
	]);

	const containerClasses = cn([
		"flex",
		"items-center",
		{
			"justify-center": alignment === "center",
			"justify-start": alignment === "left",
			"justify-end": alignment === "right"
		}
	]);

	return (
		<header className={headerClasses}>
			<div className="flex items-center justify-between w-full">
				{/* Left section - Back button */}
				{!backDisabled && (
					<div className="flex items-center">
						{
							<Button
								ghost
								onClick={navCtx.handleMoveBack}
								size="xl"
								style={{ padding: "0 0 0 10px", justifyContent: "left", position: "absolute", left: 0 }}
								variant="primary"
							>
								<AngleLeftIcon style={{ fontSize: "1.2em" }} />
							</Button>
						}
					</div>
				)}

				{/* Center section - Logo */}
				<Container className={containerClasses}>
					{theme === "shemed" ? (
						<ShemedLogo className="w-[96px]" />
					) : theme === "hemed" ? (
						<HemedLogo className="w-[96px]" />
					) : (
						<Logo className="w-20" />
					)}
				</Container>

				{/* Right section - Tags */}
				<div className="flex items-center">
					{tags.map(({ label, onClick }, index) => (
						<Badge
							key={index}
							variant="info"
							onClick={onClick}
							className={`ml-4 uppercase ${onClick != null ? "cursor-pointer" : ""}`}
						>
							{label}
						</Badge>
					))}
				</div>
			</div>
		</header>
	);
};
